import React from "react";

const ConnectingButton = ({
  buttonText,
  onClickHandler,
  createRoomButton = false
}) => {
  const buttonClass = createRoomButton
    ? "create_room_button"
    : "join_room_button";

  return (
    <button
      className={buttonClass}
      onClick={onClickHandler}
    >
      {buttonText}
    </button>
  );
};

export default ConnectingButton;
